import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["memberSelect", "companyPowerWrapper", "individualPowerWrapper", "companyPower", "individualPower", "cerSelect", "conventionalArea"]
  static values = { memberType: String }

  connect() {
    this.updatePowerFields()
  }

  memberChanged(event) {
    const selectedOption = event.target.selectedOptions[0]
    if (selectedOption) {
      this.memberTypeValue = selectedOption.dataset.memberType || ""
      this.updatePowerFields()
    }
  }

  cerChanged(event) {
    const selectedOption = event.target.selectedOptions[0]
    if (selectedOption && this.hasConventionalAreaTarget) {
      const conventionalArea = selectedOption.dataset.conventionalArea || ""
      this.conventionalAreaTarget.value = conventionalArea
    }
  }

  updatePowerFields() {
    const memberType = this.memberTypeValue

    if (memberType === "company") {
      this.showCompanyPower()
      this.hideIndividualPower()
    } else if (memberType === "individual" || memberType === "third_party_producer") {
      this.hideCompanyPower()
      this.showIndividualPower()
    } else {
      // No member selected, show both
      this.showCompanyPower()
      this.showIndividualPower()
    }
  }

  showCompanyPower() {
    if (this.hasCompanyPowerWrapperTarget) {
      this.companyPowerWrapperTarget.classList.remove("hidden")
    }
  }

  hideCompanyPower() {
    if (this.hasCompanyPowerWrapperTarget) {
      this.companyPowerWrapperTarget.classList.add("hidden")
      if (this.hasCompanyPowerTarget) {
        this.companyPowerTarget.value = ""
      }
    }
  }

  showIndividualPower() {
    if (this.hasIndividualPowerWrapperTarget) {
      this.individualPowerWrapperTarget.classList.remove("hidden")
    }
  }

  hideIndividualPower() {
    if (this.hasIndividualPowerWrapperTarget) {
      this.individualPowerWrapperTarget.classList.add("hidden")
      if (this.hasIndividualPowerTarget) {
        this.individualPowerTarget.value = ""
      }
    }
  }
}
